import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DateV2 } from "../../util/DateV2";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { IFinanzaCargoAplicado } from "../entidad/Finanza";
import { DataUtil } from "../util/Util";
import { _SvFinanzasUtilEvaluarIntervaloBloque, _SvFinanzasUtilEvaluarTipoInteres, _SvFinanzasUtilEvaluarTipoTasa } from "./FinanzaCargo";

type IAsignacionCargoDesc = Entidad.IFinanzaAsignacionCargoDescuento;

interface IGetAsignacionesResponseData {
    Cargos: Array<IAsignacionCargoDesc>;
    Descuentos: Array<Entidad.IFinanzaAsignacionInfoDescuentos>;
}


/** Uso destinado para completar la info de Edo.Cta.
 * @deprecated
 */
export async function _SvAlumnoCargosObtenerListaCargoAsignacionAlumnoV2(idAlumno: number): Promise<DataDRequest.IResultadoPeticion<IGetAsignacionesResponseData>> {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/ObtenerListaCargoAsignacionAlumnoV2";
    const params = {
        IdAlumno: idAlumno
    }

    return new Promise((resolve, reject) => {
        DataDRequest._Request<any>(url, "GET", params, (result) => {

            resolve({
                Resultado: result ? result.Resultado : -1,
                Data: result ? <IGetAsignacionesResponseData>{
                    Cargos: result.Cargos ? result.Cargos : [],
                    Descuentos: result.Descuentos ? result.Descuentos : []
                } : null
            })
        })
    })
}

export async function _SvAlumnoCargosObtenerListaCargoAsignacionAlumnoV3(idAlumno: number, idCicloEscolar: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/ObtenerListaCargoAsignacionAlumnoV3";
    const params = {
        IdAlumno: idAlumno,
        IdCicloEscolar: idCicloEscolar
    }

    return DataDRequest._Request5<Entidad.IFinanzaAsignacionCargoDescuentoV2[]>(url, "GET", params);
}

export async function _SvFinanzasObtenerCargoAplicadoPorID(idCargo: number): Promise<DataDRequest.IRequestResponseA<IFinanzaCargoAplicado>> {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/ObtenerCargo";
    const params = {
        "IdCargo": idCargo
    }
    const res = await DataDRequest._Request5<IFinanzaCargoAplicado[]>(url, "GET", params);

    return {
        Resultado: res.Resultado,
        Datos: (res.Datos?.length ? res.Datos[0] : null)
    };
}

interface IInsertAsignacionCargo {
    IdCargoPlantilla: number;
    Repeticiones: {
        FechaInicio: string;
        FechaFin: string;
    }[];
}
interface IAltaAsignacionResponseData {
    Alumno: Array<number>;
    /** Ids de las asignaciones (agrupan cada repetición) */
    CargosClon: Array<number>;
    CargosTemplate: Array<number>;
    FechaFin: Array<string>;
    FechaInicio: Array<string>;
    /** IDs de la cada asignación-repetición nueva */
    ID: Array<number>;
}
interface IDataResolvedItem {
    IdAlumno: number;
    IdCargoClon: number;
    IdCargoTemplate: number;
    FechaFin: string;
    FechaInicio: string;
    Id: number;
}
interface IDataResolved {
    /** Key -> IdAlumno */
    [idAlumno: number]: IDataResolvedItem[];
}
interface IResultResolved extends DataDRequest.IResultadoPeticion<IAltaAsignacionResponseData> {
    ResolvedData: IDataResolved;
}
export async function _SvAlumnoCargosNuevoCargoAsignacion(idsAlumno: Array<number>, idCuenta: number, datos: IInsertAsignacionCargo[], idCicloEscolar: number): Promise<IResultResolved> {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/NuevoCargoAsignacionAlumno";

    const finalParams = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        // "IdOrganizacion": data.Utils.prop_Usuario.IdOrganizacion,
        "Alumnos": idsAlumno,
        "IdCicloEscolar": idCicloEscolar,
        "IdCuenta": idCuenta,
        "Cargos": datos.map(d => {
            return {
                "IdCargo": d.IdCargoPlantilla,
                "Repeticiones": d.Repeticiones.map(dRep => {
                    const inicio = (dRep.FechaInicio) ?
                        new DateV2(dRep.FechaInicio)._ToISOLocalString() :
                        dRep.FechaInicio;
                    const fin = (dRep.FechaFin) ?
                        new DateV2(dRep.FechaFin)._ToISOLocalString() :
                        dRep.FechaFin;
                    return {
                        "FechaInicio": inicio,
                        "FechaFin": fin
                    }
                }),
            }
        })
    };
    // console.debug("FinanzaAsignacion ->", finalParams, "FINAL PARAMS - fn_InsertAsignacionDescuento");

    return new Promise((resolve, reject) => {
        DataDRequest._Request(url, "POST", finalParams, ((result: DataDRequest.IRequestResponseBase<IAltaAsignacionResponseData>) => {

            let dataResolved = <IDataResolved>{};

            result?.Datos.Alumno
                .forEach((idAlumno, i) => {
                    if (dataResolved[idAlumno] == null) {
                        dataResolved[idAlumno] = [];
                    }

                    dataResolved[idAlumno]
                        .push({
                            IdAlumno: result.Datos.Alumno[i],
                            IdCargoClon: result.Datos.CargosClon[i],
                            IdCargoTemplate: result.Datos.CargosTemplate[i],
                            FechaFin: result.Datos.FechaFin[i],
                            FechaInicio: result.Datos.FechaInicio[i],
                            Id: result.Datos.ID[i]
                        });
                });

            console.debug("FinanzaAsignacion -> _InsertAsignacionCargo", result?.Resultado, result?.Datos, dataResolved);
            resolve({
                Resultado: (result?.Resultado || -100),
                Data: result?.Datos,
                ResolvedData: dataResolved
            })
        }));
    })
}

export async function _SvAlumnoCargosNuevoCargoAsignAlumnoNoPlantilla(
    cargo: Entidad.IFinanzaCargo,
    args: {
        idAlumno: number
        idCicloEscolar: number
        strDtInicio: string
        strDtfin: string | null
        prodServ: {
            clave: string
            nombre: string
        }
        unidad: {
            clave: string
            nombre: string
        }
    }
) {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/NuevoCargoAsignAlumnoNoPlantilla";
    cargo.TipoInteres = _SvFinanzasUtilEvaluarTipoInteres(cargo)
    cargo.IntervaloBloque = _SvFinanzasUtilEvaluarIntervaloBloque(cargo)
    cargo.TipoTasa = _SvFinanzasUtilEvaluarTipoTasa(cargo)
    const params = {
        IdAlumno: args.idAlumno,
        IdCuenta: 1, // ?
        IdOrganizacion: DataUtil._Usuario.IdOrganizacion,
        IdEscuela: cargo.IdEscuela,
        IdUsuario: DataUtil._Usuario.IdUsuario,
        Nombre: cargo.Nombre,
        Valor: cargo.Valor,
        Periodicidad: cargo.Periodicidad,
        MesAplicacion: cargo.MesAplicacion,
        DiaAplicacion: cargo.DiaAplicacion,
        DiaMorosidad: cargo.DiaMorosidad,
        DiaVencimiento: cargo.DiaVencimiento,
        TipoRecargo: cargo.TipoRecargo,
        TipoInteres: cargo.TipoInteres,
        ValorRecargo: cargo.ValorRecargo,
        TipoTasa: cargo.TipoTasa,
        IntervaloBloque: cargo.IntervaloBloque,
        IdCicloEscolar: args.idCicloEscolar,
        FechaInicio: args.strDtInicio,
        FechaFin: args.strDtfin,
        ClaveProdServSAT: args.prodServ?.clave || "",
        NombreProdServSAT: args.prodServ?.nombre || "",
        ClaveUnidadSAT: args.unidad?.clave || "",
        NombreUnidadSAT: args.unidad?.nombre || "",
        IdAgrupador: cargo.IdAgrupador || 0,
        ComplementoRequerido: cargo.ComplementoRequerido || 0
    }

    return DataDRequest._Request5(url, "POST", params);
}

interface IAltaDescuentosResponseData {
    CargoAsignacion: Array<number>;
    Descuento: Array<number>;
}
export async function _SvAlumnoCargoNuevoDescuentoAsignacion(idEscuela: number, idsAsignacionRepeticiones: Array<number>, idsDescuentos: Array<number>) {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/NuevoDescuentoAsignacion";
    const params = {
        IdUsuario: DataUtil._Usuario.IdUsuario,
        Asignaciones: idsAsignacionRepeticiones,
        Descuentos: idsDescuentos,
        IdEscuela: idEscuela
    }

    return DataDRequest._Request5<IAltaDescuentosResponseData>(url, "POST", params);
}

export async function _SvAlumnoCargosEliminarCargoAsignacion(idsAsignaciones: number[]) {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/EliminarCargoAsignacion";
    const params = {
        "IdCargo": idsAsignaciones,
        "IdUsuario": DataUtil._Usuario.IdUsuario
    }

    return DataDRequest._Request5(url, "POST", params);
}

export function _SvAlumnoCargosAplicar(idsAsignacion: number[]): Promise<DataDRequest.IResultadoPeticion<undefined>> {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/CargosAplicar"; // "finanzas/CargoAplicar";
    const params = {
        // "IdAsignacion": idAsignacion,
        "Asignaciones": idsAsignacion,
        "IdUsuario": DataUtil._Usuario.IdUsuario
    }

    return new Promise(resolve => {
        DataDRequest._Request(url, "POST", params, ((result: DataDRequest.IRequestResponseBase) => {
            resolve({
                Resultado: (result?.Resultado || -100)
            })
        }))
    })
}
